module.exports = __webpack_public_path__ + "static/yoga-c4bbb80aed6b57c23378574185ee5d85.png";